(function () {
  document.querySelectorAll('[data-sonea-sticky-bar]').forEach(initStickyBar);

  function initStickyBar(bar) {
    const productEl = bar.querySelector('[data-sonea-product-json]');
    if (!productEl) return;
    const product = JSON.parse(productEl.textContent);

    const variantInput = bar.querySelector('[data-sonea-variant-id]');
    const priceEl    = bar.querySelector('[data-sonea-price]');
    const compareEl  = bar.querySelector('[data-sonea-compare]');
    const saleBadge  = bar.querySelector('[data-sonea-sale-badge]');
    const stockBadge = bar.querySelector('[data-sonea-stock-badge]');
    const button     = bar.querySelector('[data-sonea-add-button]');
    const buttonText = bar.querySelector('[data-sonea-button-text]');
    const form       = bar.querySelector('[data-sonea-form]');
    const imageEl    = bar.querySelector('[data-sonea-image]');
    const selects    = Array.from(bar.querySelectorAll('[data-sonea-option-index]'));

    // --- 1) Show / hide based on main ATC visibility ---------------------
    const mainAtc =
      document.querySelector('product-form form, [data-product-form] form, form[action*="/cart/add"]:not([data-sonea-form])') ||
      document.querySelector('product-form, [data-product-form]');

    function fallbackScroll() { bar.classList.toggle('is-visible', window.scrollY > 600); }

    if (mainAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const pastIt = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
          bar.classList.toggle('is-visible', pastIt);
        });
      }, { threshold: 0, rootMargin: '0px 0px -10% 0px' }).observe(mainAtc);
    } else {
      console.warn('[sonea-sticky-bar] main ATC not found, scroll fallback');
      window.addEventListener('scroll', fallbackScroll, { passive: true });
      fallbackScroll();
    }

    // --- 2) Money formatting ---------------------------------------------
    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format);
      }
      return new Intl.NumberFormat('de-DE', {
        style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      }).format(cents / 100);
    }

    // --- 3) Variant resolution & UI sync ---------------------------------
    function getVariant() {
      const opts = selects.map((s) => s.value);
      if (!opts.length) return product.variants[0];
      return product.variants.find((v) => v.options.every((o, i) => o === opts[i]));
    }

    function updateImage(v) {
      if (!imageEl || !v.featured_image) return;
      const src = v.featured_image.src || v.featured_image;
      if (typeof src === 'string') {
        imageEl.src = src.replace(/(\.(png|jpg|jpeg|webp|gif))/i, '_160x$1');
      }
    }

    function updateBar() {
      const v = getVariant();
      if (!v) return;

      if (variantInput) variantInput.value = v.id;
      priceEl.textContent = formatMoney(v.price);

      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (compareEl) {
        compareEl.textContent = onSale ? formatMoney(v.compare_at_price) : '';
        compareEl.toggleAttribute('hidden', !onSale);
      }
      if (saleBadge) saleBadge.toggleAttribute('hidden', !onSale);

      if (stockBadge) {
        const low = v.inventory_management === 'shopify'
          && typeof v.inventory_quantity === 'number'
          && v.inventory_quantity > 0
          && v.inventory_quantity <= 5;
        if (low) {
          stockBadge.textContent = `Only ${v.inventory_quantity} left`;
          stockBadge.removeAttribute('hidden');
        } else {
          stockBadge.setAttribute('hidden', '');
        }
      }

      button.disabled = !v.available;
      buttonText.textContent = v.available ? 'Add to bag' : 'Sold Out';

      updateImage(v);

      if (history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
    }

    selects.forEach((s) => s.addEventListener('change', updateBar));

    document.addEventListener('change', (e) => {
      if (!e.target.matches('input[name="id"], select[name="id"]')) return;
      if (e.target.closest('[data-sonea-sticky-bar]')) return;
      const id = parseInt(e.target.value, 10);
      const v  = product.variants.find((x) => x.id === id);
      if (!v) return;
      v.options.forEach((opt, i) => {
        const sel = selects[i];
        if (sel && sel.value !== opt) sel.value = opt;
      });
      updateBar();
    });

    // --- 4) Add to bag — AJAX, slide-cart opens --------------------------
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      if (button.disabled) return;
      const original = buttonText.textContent;
      buttonText.textContent = 'Adding…';
      button.disabled = true;
      try {
        const fd = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST', body: fd, headers: { Accept: 'application/json' }
        });
        if (!res.ok) throw new Error('add failed');
        const data = await res.json();
        document.dispatchEvent(new CustomEvent('cart:added', { detail: data, bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        buttonText.textContent = original;
        button.disabled = false;
      } catch (err) {
        console.error('[sonea-sticky-bar]', err);
        buttonText.textContent = original;
        button.disabled = false;
      }
    });

    updateBar();
  }
})();